import {priority} from '@priority-software/priority-proto-api/lib';
import {showFormClientSideMessage} from './messages';
import {APIActionStatus, formsStore} from '../../../stores/Form';
import texts from '../components/SidePanelForms/texts';
import {saveMailboxFeedback} from '../../../components/MailboxSendToggle/actions/consent';
import {saveMailboxToggleState} from '../../../components/MailboxSendToggle/actions/serverStorage';
import {
    MAILBOXSEND_FORM_NAME,
    MailboxSendToggleState
} from '../../../components/MailboxSendToggle/constants';
import {closeFormBySession} from './form';
import {startForm} from '../../../_shared/GWTBridge/invoke/netForm';
import {CheckedValue} from '../../../components/ToggleButton/enum';
import {mailboxSendToggleStore} from '../../../components/MailboxSendToggle/store';

// The flag will be removed after providing the missing requirements
const sendMonitoring = false;

export const handleUnsupportedFeature = (featureName: string) => {
    const session = formsStore.currentScreen.session;
    showFormClientSideMessage(session, priority.netitems.shared.Message.Type.Warning, {
        title: texts.unsupported_feature_title,
        content: texts.unsupported_feature_description,
        confirmButtonText: texts.feedback_to_classic,
        cancleButtonText: texts.feedback_stay_new,
        onConfirm: async () => {
            // Update toggle UI
            mailboxSendToggleStore.toggleUIState(CheckedValue.left);
            // Save toggle value in the server store
            await handleMailboxToggleChange();
            if (featureName && sendMonitoring) {
                // send monitoring things
                saveMailboxFeedback({
                    type: 'UI_Form_Toolbar',
                    reason: texts.feedback_reason1,
                    free_text: featureName,
                    consent: 'Y'
                });
            }
        }
    });
};

export const handleMailboxToggleChange = async () => {
    const session = formsStore.currentScreen?.session;
    if (session) {
        mailboxSendToggleStore.toggleUIState(CheckedValue.left);

        await saveMailboxToggleState(MailboxSendToggleState.CLASSIC);
        // Close the form after toggle change
        const result = await closeFormBySession(session, false);
        if (result === APIActionStatus.passed) {
            startForm(MAILBOXSEND_FORM_NAME);
        } else if (result === APIActionStatus.blocked) {
            // If close operation was blocked, revert both UI state and server storage
            mailboxSendToggleStore.toggleUIState(CheckedValue.right);
            await saveMailboxToggleState(MailboxSendToggleState.NEW);
        }
    }
};
